import * as React from "react";

import newBadgeIcon from "assets/svg/new-badge.svg";
import Block from "components/layout/Block";
import Flex from "components/layout/Flex";
import Text from "components/layout/Text";
import { Features } from "constants/features";
import useNewFeaturesInformation from "hooks/settings/use-new-features-information";

const SiloNavigationHeader: React.FC = () => {
  const isNewFeature = useNewFeaturesInformation(Features.Archive);

  return (
    <Flex justifyContent="space-between" paddingTop="30px" paddingBottom="10px" alignItems="center">
      <Text fontSize="13px" color="primaryColor50" textTransform="uppercase">
        Folders
      </Text>
      {isNewFeature && (
        <Block>
          <img src={newBadgeIcon} width="45px" height="20px" alt="" />
        </Block>
      )}
    </Flex>
  );
};

export default SiloNavigationHeader;
